export const sanitizeNumericInput = (value, { allowDecimal = true } = {}) => {
  const sanitized = String(value ?? "").replace(allowDecimal ? /[^\d.]/g : /\D/g, "");
  if (!allowDecimal) return sanitized;

  const decimalIndex = sanitized.indexOf(".");
  if (decimalIndex === -1) return sanitized;

  return `${sanitized.slice(0, decimalIndex)}.${sanitized
    .slice(decimalIndex + 1)
    .replace(/\./g, "")}`;
};

export const handleNumericInputKeyDown = (event, { allowDecimal = true } = {}) => {
  if (event.ctrlKey || event.metaKey || event.altKey || event.key.length !== 1) {
    return;
  }

  if (/^\d$/.test(event.key)) return;
  if (
    allowDecimal &&
    event.key === "." &&
    !event.currentTarget.value.includes(".")
  ) {
    return;
  }

  event.preventDefault();
};
